var map = {
	"./Commodity.png": "4e34",
	"./Commodity@2x.png": "ce22",
	"./active-radio.png": "6281",
	"./admin-icon.png": "094b",
	"./admin-img.png": "baf8",
	"./app-icon.png": "b35f",
	"./arrowD.png": "aeba",
	"./auth_step_1.png": "fe61",
	"./auth_step_2.png": "f91c",
	"./autoasyncgoodssetting.png": "a808",
	"./back_top.png": "30f2",
	"./bg-chat.png": "d3a6",
	"./bind-collaborate-icon.png": "d0fe",
	"./check-double-line.png": "0131",
	"./clash-icon.png": "8ec7",
	"./close-circle-line.png": "1d0c",
	"./clueSeas-compress-img.png": "61cb",
	"./collaborate-rules-introduce.png": "f11f",
	"./collaboration-invitation.png": "a5c2",
	"./conf-icon.png": "bc27",
	"./copy-icon.png": "513b",
	"./copy-link-active.png": "0196",
	"./copy-link.png": "13b0",
	"./customer-img.png": "b4e7",
	"./default-radio.png": "b314",
	"./default_sku.png": "a5a4",
	"./dev-img.png": "a310",
	"./developing.png": "f6fb",
	"./drag-icon.png": "a516",
	"./ecommerce.png": "7192",
	"./empty-error.png": "d3e4",
	"./empty-img.png": "145d",
	"./empty-img@2x.png": "38bc",
	"./empty-img@3x.png": "8729",
	"./empty-search-img.png": "4c0b",
	"./empty-search@2x.png": "1212",
	"./empty.png": "a794",
	"./empty_ranking.png": "825b",
	"./friendship-server-qrcode.png": "c31c",
	"./home-back-icon-1.png": "9866",
	"./home-back-icon-2.png": "f8e4",
	"./home-back-icon.png": "9390",
	"./home-icon.png": "6d2e",
	"./i-home-platform-all-active.png": "6f54e",
	"./i-home-platform-all.png": "1166",
	"./i-logo-partner.png": "ba24",
	"./i-talentCRM-myTalentDetail-Rank-1.png": "426c",
	"./i-talentCRM-myTalentDetail-Rank-1@2x.png": "025d",
	"./i-talentCRM-myTalentDetail-Rank-2.png": "8dbe1",
	"./i-talentCRM-myTalentDetail-Rank-2@2x.png": "e5ab",
	"./i-talentCRM-myTalentDetail-Rank-3.png": "55e2",
	"./i-talentCRM-myTalentDetail-Rank-3@2x.png": "da6f",
	"./icon-partner-img.png": "b3a8",
	"./icon-shop-car.png": "cd4f",
	"./icon-shop.png": "4c9c",
	"./img-empty.png": "a297",
	"./img-empty1.png": "5944",
	"./img-loading.png": "6849",
	"./img-ruleSet-example1.png": "778c",
	"./img-ruleSet-example2.png": "9a14",
	"./img-ruleSet-example3.png": "c81d",
	"./img_loading.png": "359f",
	"./jigou.png": "f453",
	"./jisu.png": "301e",
	"./layout-blueDiamond-icon.png": "5e26",
	"./lightbulb-fill.png": "d917",
	"./live_icon.png": "f88e",
	"./logo.png": "7fb0",
	"./logo2.png": "3dd4",
	"./logo2_lefttop.png": "3e17",
	"./logo_darenhoutai.png": "66a6",
	"./logo_shanjiahoutai.png": "cda2",
	"./mg-shopLibraryAddMaterial-example.png": "6a13",
	"./new-guide-img1.png": "8b5d",
	"./new-guide-img2.png": "21fc",
	"./new-guide-img3.png": "b1c0d",
	"./new-guide-img4.png": "bda9",
	"./no-data-icon.png": "b3ff",
	"./no-express.png": "8a817",
	"./no-work.png": "4187",
	"./notice-bg-lowerRight.png": "8e30",
	"./notice-bg-upperLeft.png": "20f2",
	"./now-team-img.png": "7163",
	"./promotion-icon.png": "7120",
	"./record-blue.png": "d2bc",
	"./record-icon.png": "a82d",
	"./renovation-fun-des.png": "2ba1",
	"./rest-time-line.png": "afdc",
	"./rp-flow-path.png": "fa9c",
	"./rp-kefu.png": "0b96",
	"./rp-logo.png": "0bcc",
	"./sample-cooperate-introduce.png": "c696",
	"./select-group-title.png": "04c4",
	"./share-default.png": "bf94",
	"./shop-icon.png": "1aa8",
	"./showcase-img1.png": "d34f",
	"./showcase-img2.png": "0a84",
	"./showcase-style1.png": "3c49",
	"./showcase-style2.png": "518d",
	"./sort_active.png": "ff31",
	"./sort_default.png": "48c7",
	"./split-line.png": "7fca",
	"./success.png": "b30f",
	"./team-icon.png": "d265",
	"./time-icon.png": "e93f",
	"./uchimura-icon.png": "bb8b",
	"./upload-task-icon.png": "7d19",
	"./video-empty.png": "f62b",
	"./video-play.png": "12ec",
	"./warn-icon.png": "652bd",
	"./warning-blue.png": "66ce",
	"./warning-org.png": "9e2d",
	"./weal.png": "6ef8",
	"./wx-icon.png": "4cf0"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0eee";